import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";

const slice = createSlice({
    name: "transactions",
    initialState: {
        information: [],
        isUpdating: false,
        updateErrors: [],
    },
    reducers: {
        informationRetrieving: (transactions, action) => {
            transactions.information = [];
        },
        informationRetrieved: (transactions, action) => {
            transactions.information = action.payload ? action.payload : [];
        },
        informationRetrievalFailed: (transactions, action) => {
            transactions.information = [];
        },
        detailsUpdating: (transactions, action) => {
            transactions.isUpdating = true;
        },
        detailsUpdated: (transactions, action) => {
            transactions.isUpdating = false;
        },
        detailsUpdateFailed: (transactions, action) => {
            transactions.isUpdating = false;
            transactions.updateErrors = action.payload ? action.payload : "Error";
        },
    },
});

export const {
    informationRetrieving,
    informationRetrieved,
    informationRetrievalFailed,
    detailsUpdating,
    detailsUpdated,
    detailsUpdateFailed,
} = slice.actions;

export default slice.reducer;

export const getTransactions = (data) =>
    apiCallBegan({
        serviceUrl: process.env.REACT_APP_BASICSERVICE,
        url: "/api/transactions?prospectID=" + data,
        method: "get",
        onStart: informationRetrieving.type,
        onSuccess: informationRetrieved.type,
        onError: informationRetrievalFailed.type,
    });

export const getAllTransactions = (data) =>
    apiCallBegan({
        serviceUrl: process.env.REACT_APP_BASICSERVICE,
        url: "/api/transactions?customerID=" + data,
        method: "get",
        onStart: informationRetrieving.type,
        onSuccess: informationRetrieved.type,
        onError: informationRetrievalFailed.type,
    });

export const addTransaction = (data) =>
    apiCallBegan({
        serviceUrl: process.env.REACT_APP_BASICSERVICE,
        url: "api/transactions/add",
        method: "post",
        data: data,
        onStart: detailsUpdating.type,
        onSuccess: detailsUpdated.type,
        onError: detailsUpdateFailed.type,
    });

export const getTransactionsInformation = createSelector(
    (state) => state.entities.transactions,
    (transactions) => transactions.information
);

export const getTransactionsUpdating = createSelector(
    (state) => state.entities.transactions,
    (transactions) => transactions.isUpdating
);